class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

static renderProductGridContainer(html) {
  document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
    .parseFromString(html, 'text/html')
    .getElementById('ProductGridContainer').innerHTML;

  document
    .getElementById('ProductGridContainer')
    .querySelectorAll('.scroll-trigger')
    .forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

  // Sync mobile sort drawer selected state.
  // The drawer lives outside ProductGridContainer so it never gets
  // updated during AJAX re-renders. We read sort_by from the URL
  // and update the selected button manually after every render.
  const urlParams = new URLSearchParams(window.location.search);
  const sortByParam = urlParams.get('sort_by');
  const fastestDeliveryBtn = document.querySelector(
    '.mobile-facets__sort-drawer-option[data-value="fastest-delivery"]'
  );
  const activeValue = (!sortByParam && fastestDeliveryBtn)
    ? 'fastest-delivery'
    : (sortByParam || 'manual');

  document.querySelectorAll('.mobile-facets__sort-drawer-option').forEach(btn => {
    btn.classList.toggle('selected', btn.dataset.value === activeValue);
  });
}

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Custom Sort Dropdown Handler
document.addEventListener('DOMContentLoaded', function() {
  // Desktop Sort Dropdown
  const sortWrappers = document.querySelectorAll('.facets__sort-wrapper');
  sortWrappers.forEach(wrapper => {
    const summary = wrapper.querySelector('summary');
    const dropdown = wrapper.querySelector('.facets__sort-dropdown');
    const options = dropdown?.querySelectorAll('.facets__sort-option');

    if (summary && dropdown) {
      // Let the native details element handle the toggle
      // No need to prevent default or manually toggle

      options?.forEach(option => {
        option.addEventListener('click', () => {
          const value = option.getAttribute('data-value');
          const optionText = option.textContent.trim();
          const buttonText = summary?.querySelector('span');
          
          // Update button text immediately
          if (buttonText) {
            buttonText.textContent = optionText;
          }
          
          // Update selected state visually
          options.forEach(opt => opt.classList.remove('selected'));
          option.classList.add('selected');
          
          // Create URL with sort parameter
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          
          // Update page without reload using AJAX
          const searchParams = url.searchParams.toString();
          FacetFiltersForm.renderPage(searchParams, null, true);
          
          // Close dropdown
          wrapper.removeAttribute('open');
        });
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target)) {
          wrapper.removeAttribute('open');
        }
      });
    }
  });

  // Mobile Sort Drawer
  const mobileSortButton = document.querySelector('[data-mobile-sort-open]');
  const mobileSortDrawer = document.querySelector('[data-mobile-sort-drawer]');
  const mobileSortOverlay = document.querySelector('[data-mobile-sort-overlay]');
  const mobileSortClose = document.querySelector('[data-mobile-sort-close]');
  const mobileSortOptions = document.querySelectorAll('.mobile-facets__sort-drawer-option');

  if (mobileSortButton && mobileSortDrawer && mobileSortOverlay) {
    mobileSortButton.addEventListener('click', () => {
      mobileSortDrawer.classList.add('active');
      mobileSortOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    const closeDrawer = () => {
      mobileSortDrawer.classList.remove('active');
      mobileSortOverlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    mobileSortClose?.addEventListener('click', closeDrawer);
    mobileSortOverlay.addEventListener('click', closeDrawer);

    mobileSortOptions.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-value');
        
        // Create URL with sort parameter
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        
        // Update page without reload using AJAX
        const searchParams = url.searchParams.toString();
        FacetFiltersForm.renderPage(searchParams, null, true);
        
        closeDrawer();
      });
    });
  }

  // Mobile Filter Drawer
  const mobileFilterButton = document.querySelector('[data-mobile-filter-open]');
  const mobileFilterDrawer = document.querySelector('[data-mobile-filter-drawer]');
  const mobileFilterOverlay = document.querySelector('[data-mobile-filter-overlay]');
  const mobileFilterClose = document.querySelector('[data-mobile-filter-close]');
  const mobileFilterApply = document.querySelector('[data-mobile-filter-apply]');

  if (mobileFilterButton && mobileFilterDrawer && mobileFilterOverlay) {
    mobileFilterButton.addEventListener('click', () => {
      mobileFilterDrawer.classList.add('active');
      mobileFilterOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    const closeFilterDrawer = () => {
      mobileFilterDrawer.classList.remove('active');
      mobileFilterOverlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    mobileFilterClose?.addEventListener('click', closeFilterDrawer);
    mobileFilterOverlay.addEventListener('click', closeFilterDrawer);

    // Apply Filters button
    mobileFilterApply?.addEventListener('click', () => {
      // Create URL and clear all filter parameters
      const url = new URL(window.location.href);
      
      // Remove all existing filter parameters
      const keysToDelete = [];
      for (const key of url.searchParams.keys()) {
        if (key.startsWith('filter.')) {
          keysToDelete.push(key);
        }
      }
      keysToDelete.forEach(key => url.searchParams.delete(key));
      
      // Get all price inputs
      const minPriceInput = mobileFilterDrawer.querySelector('input[name*="filter.v.price.gte"]');
      const maxPriceInput = mobileFilterDrawer.querySelector('input[name*="filter.v.price.lte"]');
      
      if (minPriceInput && minPriceInput.value && minPriceInput.value.trim() !== '') {
        url.searchParams.set(minPriceInput.name, minPriceInput.value);
      }
      
      if (maxPriceInput && maxPriceInput.value && maxPriceInput.value.trim() !== '') {
        url.searchParams.set(maxPriceInput.name, maxPriceInput.value);
      }
      
      // Get all checked filter checkboxes
      const checkedFilters = mobileFilterDrawer.querySelectorAll('.mobile-facets__filter-checkbox-input:checked');
      checkedFilters.forEach(checkbox => {
        url.searchParams.append(checkbox.name, checkbox.value);
      });
      
      // Update page without reload using AJAX
      const searchParams = url.searchParams.toString();
      FacetFiltersForm.renderPage(searchParams, null, true);
      
      closeFilterDrawer();
    });
  }

  // Desktop Filter Checkbox handling
  const desktopFilterCheckboxes = document.querySelectorAll('.facets__filter-checkbox-input');
  desktopFilterCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      // Create URL and rebuild filter parameters
      const url = new URL(window.location.href);
      
      // Remove all existing filter option parameters (but keep price and sort)
      const keysToDelete = [];
      for (const key of url.searchParams.keys()) {
        if (key.startsWith('filter.v.option.')) {
          keysToDelete.push(key);
        }
      }
      keysToDelete.forEach(key => url.searchParams.delete(key));
      
      // Get all checked checkboxes in the desktop filter dropdown
      const allCheckedBoxes = document.querySelectorAll('.facets__filter-checkbox-input:checked');
      allCheckedBoxes.forEach(cb => {
        url.searchParams.append(cb.name, cb.value);
      });
      
      // Update page without reload using AJAX
      const searchParams = url.searchParams.toString();
      FacetFiltersForm.renderPage(searchParams, null, true);
    });
  });

  // Filter By dropdown (desktop)
  const filterWrappers = document.querySelectorAll('.facets__filter-wrapper');
  filterWrappers.forEach(wrapper => {
    const summary = wrapper.querySelector('summary');
    const dropdown = wrapper.querySelector('.facets__filter-dropdown');

    if (summary && dropdown) {
      // Let the native details element handle the toggle
      // No need to prevent default or manually toggle

      // Handle price input changes with debounce
      const priceInputs = dropdown.querySelectorAll('.facets__filter-price-input');
      let priceTimeout;
      
      priceInputs.forEach(input => {
        input.addEventListener('input', () => {
          clearTimeout(priceTimeout);
          priceTimeout = setTimeout(() => {
            // Create URL and rebuild filter parameters
            const url = new URL(window.location.href);
            
            // Remove existing price filters
            url.searchParams.delete('filter.v.price.gte');
            url.searchParams.delete('filter.v.price.lte');
            
            // Get both price inputs
            const minInput = dropdown.querySelector('input[name*="filter.v.price.gte"]');
            const maxInput = dropdown.querySelector('input[name*="filter.v.price.lte"]');
            
            // Add new price values if they exist and are not empty
            if (minInput && minInput.value && minInput.value.trim() !== '') {
              url.searchParams.set(minInput.name, minInput.value);
            }
            if (maxInput && maxInput.value && maxInput.value.trim() !== '') {
              url.searchParams.set(maxInput.name, maxInput.value);
            }
            
            // Update page without reload using AJAX
            const searchParams = url.searchParams.toString();
            FacetFiltersForm.renderPage(searchParams, null, true);
          }, 800);
        });
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target)) {
          wrapper.removeAttribute('open');
        }
      });
    }
  });
});

// Mobile Filter Expandable Scroll
document.addEventListener('DOMContentLoaded', function() {
  const expandables = document.querySelectorAll('.mobile-facets__filter-expandable');
  
  expandables.forEach(expandable => {
    expandable.addEventListener('toggle', function() {
      if (this.open) {
        // Wait for the content to expand
        setTimeout(() => {
          const content = this.querySelector('.mobile-facets__filter-expandable-content');
          if (content) {
            // Scroll the content into view smoothly
            content.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'nearest',
              inline: 'nearest'
            });
          }
        }, 100);
      }
    });
  });
});

// Filter Pills Toggle Handler - for Parts-related collection filter pills
document.addEventListener('DOMContentLoaded', function() {
  const filterPills = document.querySelectorAll('.facets__filter-pills .facet-pill');
  const partsRelatedCollections = ['parts', 'gear', 'seating', 'paddles', 'apparel', 'accessories'];
  const currentPath = window.location.pathname;
  
  // Check if we're on a parts-related collection
  let isPartsRelated = false;
  partsRelatedCollections.forEach(handle => {
    if (currentPath.includes('/collections/' + handle)) {
      isPartsRelated = true;
    }
  });
  
  if (!isPartsRelated) return; // Only apply to parts-related collections
  
  filterPills.forEach(pill => {
    // Skip kayak collection navigation pills
    if (pill.href.includes('/collections/flap-drive') || 
        pill.href.includes('/collections/propeller-drive') || 
        pill.href.includes('/collections/motorized-kayaks') ||
        (pill.href.includes('/collections/all') && pill.textContent.trim() === 'All')) {
      return;
    }
    
    pill.addEventListener('click', function(e) {
      const isActive = this.classList.contains('active');
      
      if (isActive) {
        // If clicking an active filter pill, go back to Parts collection
        e.preventDefault();
        window.location.href = '/collections/parts';
      }
      // If not active, let the default behavior (navigate to that collection) happen
    });
  });
});
